import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import { clsx } from 'clsx';
import { nextSort, type Sort } from './sort';

/** En-tête de colonne triable : clic pour trier, flèche indiquant l'ordre courant (aria-sort pour les lecteurs d'écran) */
export function SortableHeader<Key extends string>({
  label,
  sortKey,
  sort,
  onSort,
  className,
}: {
  label: string;
  sortKey: Key;
  sort: Sort<Key>;
  onSort: (sort: Sort<Key>) => void;
  className?: string;
}) {
  const active = sort.key === sortKey;
  const Icon = !active ? ArrowUpDown : sort.direction === 'asc' ? ArrowUp : ArrowDown;

  return (
    <th className={className} aria-sort={active ? (sort.direction === 'asc' ? 'ascending' : 'descending') : 'none'}>
      <button
        type="button"
        onClick={() => onSort(nextSort(sort, sortKey))}
        className={clsx(
          // Un bouton n'hérite pas de la police : même taille, graisse et casse que les en-têtes non triables
          'inline-flex items-center gap-1.5 [font:inherit] uppercase tracking-[inherit] hover:text-slate-900 transition-colors',
          active && 'text-slate-900',
        )}
      >
        {label}
        <Icon className={clsx('w-3.5 h-3.5', active ? 'text-blue-600' : 'text-slate-300')} />
      </button>
    </th>
  );
}
